// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'information';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 17.424A8.389 8.389 0 0 0 17.424 9 8.389 8.389 0 0 0 9 .576 8.389 8.389 0 0 0 .576 9 8.389 8.389 0 0 0 9 17.424z' />
    <path d='M8.208 7.848H9.36v4.536m-1.152 0h2.232' />
    <circle cx='9.25' cy='5.25' r='.25' fill='currentColor' />
  </g>
);

export const viewBox = '0 0 18 18';
